export const namespace = 'activityticker'
